import styled from 'styled-components'

export const GuardianDataContainer = styled.div`
  .subtitle {
    color: var(--grey16);
    margin-bottom: 2rem;
    font-size: 14px;
    line-height: 24px;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`
